import React, {Component} from 'react';
import PageContainer from './PageContainer';
import styles from './FindAgents.scss';

class FindAgents extends Component {
  render() {
    return (
    <PageContainer>
        <div id="oa-oth-lp" className={styles.agentIframeContainer}>
          <iframe id="oa-oth-lp-iframe"  className={styles.iframe} src="//www.openagent.com.au/findagents/54/index.php" frameBorder="0" width="100%" scrolling="no"></iframe>
        </div>
        <script src="https://cdn.openagent.com.au/js/oa-oth-lp.js"></script>
        
    </PageContainer>
    );
  }
}

export default FindAgents;